import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f548ce04"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "more-info-container"
};
const _hoisted_2 = {
  class: "more-info-list"
};
const _hoisted_3 = {
  key: 0,
  class: "point"
};
const _hoisted_4 = {
  class: "more-info-list"
};
const _hoisted_5 = {
  class: "more-info-list"
};
const _hoisted_6 = {
  key: 0,
  class: "more-info__footer"
};
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { isAndroidNative, isHarmonyNative, isIOSNative, sendMessage } from '@xunlei/universal-native-api';
import MoreInfoItem from '@remote/components/MoreInfoItem.vue';
import { USER_PROTOCOL_URL, PRIVACY_PROTOCOL_URL, PAN_PROTOCOL_URL, VIP_PROTOCOL_URL, SUPPORT_SHORTCUT_CODE, TDM_PROTOCOL_URL, isAndroidTM } from '@remote/constant/index';
import { getLocalValue, setLocalValue, toast } from '@remote/utils/index';
import { openPopCleanUpDB } from '@remote/utils/dialog';
import global from '@remote/store/constantStore';
import { useVConsole } from '@remote/composable/vconsole';
import { stat } from '@remote/utils/stat';
import { useEnvStore } from '@remote/store/env';
import router from '@remote/router';
import { useDeviceStore } from '@remote/store/device';
import PageHeader from '@remote/components/PageHeader.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const device = global.device;
    document.title = '更多';
    const store = useStore();
    const envStore = useEnvStore();
    const {
      enableClick
    } = useVConsole();
    const showPoint = ref(!getLocalValue('hideShortcutPoint'));
    const action = computed(() => {
      return store.state.action;
    });
    const showHeader = computed(() => {
      return store.getters.showHeader;
    });
    const isLogoutHide = computed(() => {
      return envStore.isInPC || envStore.isInMac || isAndroidNative || isHarmonyNative;
    });
    const deviceInfoWatchData = computed(() => {
      return store.state.deviceInfoWatchData;
    });
    const isFullScreen = computed(() => {
      return store.getters.isFullScreen;
    });
    const clientVersion = computed(() => {
      var _deviceInfoWatchData$, _deviceInfoWatchData$2;
      return (_deviceInfoWatchData$ = (_deviceInfoWatchData$2 = deviceInfoWatchData.value) === null || _deviceInfoWatchData$2 === void 0 ? void 0 : _deviceInfoWatchData$2.client_version) !== null && _deviceInfoWatchData$ !== void 0 ? _deviceInfoWatchData$ : '';
    });
    const isShowShortcut = computed(() => {
      return isAndroidNative && device.versionCode >= SUPPORT_SHORTCUT_CODE || isIOSNative;
    });
    const deviceStore = useDeviceStore();
    const isCleanUpShow = computed(() => {
      var _deviceStore$currentD;
      return !((_deviceStore$currentD = deviceStore.currentDeviceRef) !== null && _deviceStore$currentD !== void 0 && _deviceStore$currentD.util.isVersionSmallerThan('3.18.0'));
    });
    const logout = isLogout => {
      if (isAndroidNative || isIOSNative) {
        toast('请在迅雷客户端中退出登录，或在设备列表中解绑设备');
        return;
      }
      store.dispatch('logout', isLogout);
    };
    watch(action, val => {
      if (val === 'logout') {
        logout(true);
      }
    });
    const clickStat = clickID => {
      stat({
        category: 'remote_control_h5',
        action: 'mytab_page_click',
        data: {
          click_id: clickID
        }
      });
    };
    const goShortcut = () => {
      clickStat('desktop_icon');
      if (showPoint.value) {
        setLocalValue('hideShortcutPoint', true);
        showPoint.value = false;
      }
      if (isAndroidNative) {
        sendMessage({
          platform: 'android',
          name: 'xlInstallShortcut',
          params: {
            title: '远程设备',
            url: 'xunleiapp://xunlei.com/webview?url=https%3A%2F%2Fpan.xunlei.com%2Fyc%2F%3FnoActionBar%3Dtrue%26noStatusBar%3Dtrue',
            icon: 'data:image/png;base64,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',
            id: 'yc',
            silent: false
          }
        });
      } else if (isIOSNative) {
        location.assign(`xunlei://hybrid/openUrl?url=${encodeURIComponent('https://pan.xunlei.com/yc/shortcut.html')}`);
      }
    };
    const goHelp = () => {
      clickStat('help');
      router.push({
        name: 'help',
        query: router.currentRoute.value.query
      });
    };
    const goAbout = () => {
      clickStat('about');
      router.push({
        name: 'about',
        query: router.currentRoute.value.query
      });
    };
    const handleBack = () => {
      router.go(-1);
    };
    const goProtocol = title => {
      let URL = '';
      switch (title) {
        case '迅雷产品服务使用协议':
          URL = USER_PROTOCOL_URL;
          break;
        case '迅雷隐私权政策':
          URL = PRIVACY_PROTOCOL_URL;
          break;
        case '迅雷云盘服务协议':
          URL = PAN_PROTOCOL_URL;
          break;
        case '迅雷会员服务协议':
          URL = VIP_PROTOCOL_URL;
          break;
        case '迅雷网盘服务协议':
          URL = TDM_PROTOCOL_URL;
          break;
      }
      store.commit('update', {});
      router.push({
        name: 'pluginIframe',
        query: {
          ...router.currentRoute.value.query,
          currentIframeUrl: URL,
          currentIframeTitle: title,
          currentIframeShowClose: 0
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "more-info",
        onClick: _cache[6] || (_cache[6] = _withModifiers(
        //@ts-ignore
        (...args) => _unref(enableClick) && _unref(enableClick)(...args), ["stop"]))
      }, [showHeader.value ? (_openBlock(), _createBlock(PageHeader, {
        key: 0,
        onBack: handleBack,
        title: "更多"
      })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(MoreInfoItem, {
        title: "帮助与反馈",
        onClick: goHelp
      }), clientVersion.value ? (_openBlock(), _createBlock(MoreInfoItem, {
        key: 0,
        title: "关于迅雷",
        onClick: goAbout
      })) : _createCommentVNode("", true), isShowShortcut.value ? (_openBlock(), _createBlock(MoreInfoItem, {
        key: 1,
        title: "添加桌面快捷方式",
        onClick: goShortcut
      }, {
        extra: _withCtx(() => [showPoint.value && clientVersion.value.match(/2.13/) ? (_openBlock(), _createElementBlock("span", _hoisted_3)) : _createCommentVNode("", true)]),
        _: 1
      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [isCleanUpShow.value ? (_openBlock(), _createBlock(MoreInfoItem, {
        key: 0,
        title: "速度优化",
        onClick: _unref(openPopCleanUpDB)
      }, null, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(MoreInfoItem, {
        title: "用户协议",
        onClick: _cache[0] || (_cache[0] = $event => goProtocol('迅雷产品服务使用协议'))
      }), _createVNode(MoreInfoItem, {
        title: "隐私协议",
        onClick: _cache[1] || (_cache[1] = $event => goProtocol('迅雷隐私权政策'))
      }), _unref(isAndroidTM) ? (_openBlock(), _createBlock(MoreInfoItem, {
        key: 0,
        title: "网盘协议",
        onClick: _cache[2] || (_cache[2] = $event => goProtocol('迅雷网盘服务协议'))
      })) : (_openBlock(), _createBlock(MoreInfoItem, {
        key: 1,
        title: "云盘协议",
        onClick: _cache[3] || (_cache[3] = $event => goProtocol('迅雷云盘服务协议'))
      })), _createVNode(MoreInfoItem, {
        title: "会员协议",
        onClick: _cache[4] || (_cache[4] = $event => goProtocol('迅雷会员服务协议'))
      })]), !isLogoutHide.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", {
        class: "more-info__logout",
        onClick: _cache[5] || (_cache[5] = $event => logout(false))
      }, " 退出登录 ")])) : _createCommentVNode("", true)])]);
    };
  }
});